import { render, staticRenderFns } from "./WidgetLabel.vue?vue&type=template&id=2ef06901&lang=pug"
import script from "./WidgetLabel.vue?vue&type=script&lang=js"
export * from "./WidgetLabel.vue?vue&type=script&lang=js"
import style0 from "./WidgetLabel.vue?vue&type=style&index=0&id=2ef06901&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
